module.exports = __webpack_public_path__ + "img/icon2.90dc9c66.png";